import React, { useState, useEffect } from 'react';
import './Snow.css';
const Snowflake = ({ id }) => {
  const [animationDelay, setAnimationDelay] = useState('0s');
  const [fontSize, setFontSize] = useState('10px');

  useEffect(() => {
    const newDelay = `${(Math.random() * 16).toFixed(2)}s`;
    const newFontSize = `${Math.floor(Math.random() * 10) + 10}px`;

    setAnimationDelay(newDelay);
    setFontSize(newFontSize);
  }, []);

  return (
    <p className='Snowflake' id={`item${id}`} style={{ animationDelay, fontSize }}>
      *
    </p>
  );
};

const Snow = () => {
  const numFlakes = 200;

  const snow = new Array(numFlakes).fill('').map((el, i) => <Snowflake key={i} id={i} />);

  return <div className='Snow'>{snow}</div>;
};

export default Snow;
